import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id CDCB7012-AD69-4B80-A64E-FDA1375271AD
 * name signal-hspa-plus
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/signal-hspa-plus.svg
 * tags
 * - Cellphone / Phone 
 */
export const SignalHspaPlusIcon = createSvgIcon(<><path d="M19,8V11H22V14H19V17H16V14H13V11H16V8H19M5,10.5H8V4.5H11V19.5H8V13.5H5V19.5H2V4.5H5V10.5Z" /></>, 'SignalHspaPlusIcon');
export default SignalHspaPlusIcon